import { render, staticRenderFns } from "./ContentBlockTitle.vue?vue&type=template&id=1903569e&scoped=true&functional=true&"
import script from "./ContentBlockTitle.vue?vue&type=script&lang=js&"
export * from "./ContentBlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockTitle.vue?vue&type=style&index=0&id=1903569e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1903569e",
  null
  
)

export default component.exports